'use strict';

function CompanyPublicationCompanyOrderSubcriptionService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/subcriptions/:subcriptionId', {}, {
    'update': {
      method: 'PUT'
    },
    'updateItems':  {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/subcriptions/:subcriptionId/items',
      method: 'POST'
    },
    'updateItem':  {
        url: config.apiBase + '/companies/:companyId/publications/:publicationId/subcriptions/:subcriptionId/items/:itemId',
        method: 'PUT'
    },
    'deleteItem': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/subcriptions/:subcriptionId/items/:itemId',
      method: 'DELETE'
    },
    'createNextOrder':  {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/subcriptions/:subcriptionId/orders',
      method: 'POST'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyPublicationCompanyOrderSubcriptionService', ['$resource', 'config', CompanyPublicationCompanyOrderSubcriptionService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/companyOrderSubcription/CompanyPublicationCompanyOrderSubcriptionService.js
// module id = 65
// module chunks = 0